import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ContactItemProps extends ComponentPropsWithRef<"div"> {
  content: ReactNode;
}

export const ContactItem = forwardRef<HTMLDivElement, ContactItemProps>(
  ({ content, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "wb-flex wb-flex-row wb-items-center wb-gap-4 wb-text-primary",
        className,
      )}
      {...rest}
    >
      <div className="wb-flex wb-flex-row wb-items-center wb-gap-4">
        {content}
      </div>
    </div>
  ),
);

ContactItem.displayName = "ContactItem";
